import { InfiniteScrollCustomEvent } from '@ionic/angular';
import { Update } from '@ngrx/entity';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  DiscussionCreateRequest,
  DiscussionListItem,
  DiscussionModel,
  DiscussionType,
} from '../models/discussion.models';
import { DiscussionFormValue } from '../models/form/discussion-form.model';

export const CreateDiscussionComponentActions = createActionGroup({
  source: 'Create Discussion Component',
  events: {
    'Create Discussion Clicked': props<{ request: DiscussionCreateRequest }>(),
  },
});

export const CreateDiscussionEffectsActions = createActionGroup({
  source: 'Create Discussion Effects',
  events: {
    'Create Discussion Succeeded': props<{ discussion: DiscussionModel }>(),
    'Create Discussion Failed': props<{ error: unknown }>(),
  },
});

export const DiscussionDetailActions = createActionGroup({
  source: 'Discussion Detail Component',
  events: {
    'Discussion Detail Saved': props<{ update: Update<DiscussionListItem> }>(),
    'Discussion Detail Update Reverted': props<{ update: Update<DiscussionListItem> }>(),
    'Discussion Detail Deleted': props<{ id: string }>(),
    'Discussion Detail Delete Failed': props<{ discussion: DiscussionModel }>(),
  },
});

export const DiscussionListActions = createActionGroup({
  source: 'Discussion List View',
  events: {
    'Discussion List Init': emptyProps(),
    'Ion Scroll Event': props<{ event?: InfiniteScrollCustomEvent }>(),
    'Discussion Refresh': emptyProps(),
  },
});

export const DiscussionListEffectActions = createActionGroup({
  source: 'Discussion List Effects',
  events: {
    'Discussion List Requested': props<{ event?: InfiniteScrollCustomEvent }>(),
    'Discussion List Request Succeeded': props<{
      data: DiscussionListItem[];
      totalDiscussions: number;
      event?: InfiniteScrollCustomEvent;
    }>(),
    'Discussion List Request Failed': props<{ event?: InfiniteScrollCustomEvent }>(),
    'Discussion List Init': props<{ currentUserId: string }>(),
  },
});

export const DiscussionFormComponentActions = createActionGroup({
  source: 'Discussion Form Component',
  events: {
    'Discussion Form Init': emptyProps(),
    'Discussion Form Destroyed': emptyProps(),
    'Discussion Form Saved': props<{
      formValue: DiscussionFormValue;
      finished: boolean;
    }>(),
  },
});

export const DiscussionFormEffectsActions = createActionGroup({
  source: 'Discussion Form Effects',
  events: {
    'Discussion Requested': emptyProps(),
    'Discussion Request Succeeded': props<{
      discussion: DiscussionModel;
    }>(),
    'Discussion Request Failed': emptyProps(),

    'Discussion Form Save Succeeded': props<{ finished: boolean; _id: string; discussionType: DiscussionType }>(),
    'Discussion Form Save Failed': emptyProps(),
  },
});

export type DiscussionFilters = {
  selectedUserId: string;
  showCompleted: boolean;
};
export type DiscussionFilterFields = keyof DiscussionFilters;

export const DiscussionToolbarComponentActions = createActionGroup({
  source: 'Discussion Toolbar Component',
  events: {
    'Sort Direction Changed': emptyProps(),
    'List Filtered': props<{ filters?: DiscussionFilters }>(),
  },
});
